import ActionTypes from "../../constants/actionTypes";
import * as definitions from "./definitions";
import { shouldCleanup } from '../../utils/navigationCleanup';

const initialState = {
  ...definitions,
  data: {},
  dataIds: [],
  showMoreHidden: false
};

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_USER_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.reduce((prev, cur) => {
            prev[cur.id] = cur;
            return prev;
          }, {})
        },
        dataIds: [...new Set([...state.dataIds, ...action.payload.map(each => each.id)])]
      };
    case ActionTypes.RESTART_USERS:
      return {
        ...state,
        data: action.payload.reduce((prev, cur) => {
          prev[cur.id] = cur;
          return prev;
        }, {}),
        dataIds: action.payload.map(each => each.id),
      }
    case ActionTypes.DELETE_USERS:
      action.payload.forEach(each => delete state.data[each]);
      return {
        ...state,
        dataIds: state.dataIds.filter(each => !action.payload.includes(each))
      };
    case ActionTypes.TOGGLE_USER:
      state.data[action.payload.id].isActive = action.payload.bool;
      return {
        ...state
      };
    case ActionTypes.SHOW_MORE_USERS:
      return {
        ...state,
        showMoreHidden: action.payload
      }
    case ActionTypes.LOCATION_CHANGE:
        return shouldCleanup(action.payload) ? {...initialState} : state;
    case ActionTypes.RESET_PASSWORD_BTN_HIDE :
        const menuItems = state.table.menu
        menuItems.splice(1,1)
        state.table.menu = menuItems
        return {
          ...state
        }
    default:
      return state;
  }
}
